import { useState } from 'react';
import BasicLayout from 'layout/BasicLayout';

import { useLocation, useNavigate } from 'react-router-dom';

import Card from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';
import CardContent from '@mui/material/CardContent';

import ArgonBox from 'component/Argon/ArgonBox';
import ArgonInput from 'component/Argon/ArgonInput';
import ArgonButton from 'component/Argon/ArgonButton';

import { useForm, Controller } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { string } from 'yup';

import useAuth from 'auth/hook/useAuth';

export default function ResetPwd() {
  const { auth, setAuth, persist, setPersist } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const [showPwd, setShowPwd] = useState(false);

  const {
    setError,
    control,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver({
      email: string().email().required(),
    }),
    defaultValues: {
      email: '',
    },
  });

  const onSubmit = (data) => {
    console.log(data);
  };

  return (
    <BasicLayout>
      <Card>
        <CardHeader sx={{ textAlign: 'center' }} title="ลืมหรัสผ่าน" subheader="ส่งรหัสไปที่อีเมลที่ลงทะเบียนไว้" />
        <CardContent>
          <ArgonBox component="form" role="form">
            <ArgonBox mb={2}>
              <Controller
                name="email"
                control={control}
                render={({ field }) => (
                  <ArgonInput
                    name="email"
                    type="email"
                    placeholder="อีเมล"
                    size="large"
                    error={!!errors?.email}
                    {...field}
                  />
                )}
              />
            </ArgonBox>

            <ArgonBox mt={4} mb={1}>
              <ArgonButton color="info" size="large" fullWidth onClick={handleSubmit(onSubmit)}>
                ส่ง
              </ArgonButton>
            </ArgonBox>
          </ArgonBox>
        </CardContent>
      </Card>
    </BasicLayout>
  );
}
